import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  IconButton,
  Popover,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  ListItemIcon,
  Divider,
  Grid,
  FormControl,
  // Select,
  // MenuItem,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import AccountCircle from "@material-ui/icons/AccountCircle";
import PersonIcon from "@material-ui/icons/Person";
import MeetingRoomIcon from "@material-ui/icons/MeetingRoom";

import {
  selectProject,
  selectSelectedProject,
} from "../../../features/authentication/authenticationSlice";

function AccountMenu({ classes, userDetails, onLogout }) {
  const selectedProject = useSelector(selectSelectedProject);
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  // console.log("userDetails: %o", userDetails);

  const handlePopoverOpen = (event) => {
    if (anchorEl) {
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleChangeProject = (event) => {
    dispatch(selectProject(event.target.value));
  };

  return (
    <Grid container direction="row" justify="flex-end">
      {/* {Array.isArray(userDetails?.projects) &&
        userDetails?.projects.length > 1 && (
          <FormControl className={classes.projectSelectForm} size="small">
            <Select
              value={selectedProject.id}
              onChange={handleChangeProject}
              className={classes.projectSelect}
            >
              {userDetails?.projects.map((project) => (
                <MenuItem key={project} value={project}>
                  {project}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )} */}
      <IconButton color="inherit" onClick={handlePopoverOpen}>
        <AccountCircle />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        onClose={handlePopoverClose}
        className={classes.accountMenuPopover}
      >
        <List>
          <ListItem>
            <ListItemAvatar>
              <Avatar>
                <PersonIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={userDetails.name}
              secondary={userDetails.username}
            />
          </ListItem>
        </List>
        <Divider />
        {Array.isArray(userDetails?.projects) &&
          userDetails?.projects.length > 1 && (
            <div>
              <FormControl
                className={classes.projectSelectFormMenu}
                size="small"
              >
                <FormLabel component="legend">Selected Project</FormLabel>
                <RadioGroup
                  aria-label="project"
                  name="project"
                  value={selectedProject?.id || "DUMMY"}
                  onChange={handleChangeProject}
                >
                  {userDetails?.projects.map((project) => (
                    <FormControlLabel
                      key={"project_" + project}
                      value={project}
                      control={<Radio />}
                      label={project}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
              <Divider />
            </div>
          )}
        <List>
          <ListItem button onClick={onLogout}>
            <ListItemIcon>
              <MeetingRoomIcon />
            </ListItemIcon>
            <ListItemText primary="Logout" />
          </ListItem>
        </List>
      </Popover>
    </Grid>
  );
}

export default AccountMenu;
